var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"kyc-chart-statistics-summary",domProps:{"textContent":_vm._s(_vm.summary)}})}
var staticRenderFns = []

export { render, staticRenderFns }